import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { GradientTypography } from '../gradients/GradientTypography';
import { useMobile } from 'src/hooks/useMobile';
import { PartnerCard, PartnerCardProps } from './PartnerCard';

export type PartnersListProps = {
  partners: PartnerCardProps[];
};

export function PartnersList(props: PartnersListProps) {
  const isMobile = useMobile();
  const { partners } = props;
  return (
    <Box sx={{ width: 'min(1136px, 100%)' }}>
      {!isMobile && (
        <GradientTypography
          gradientColor="primary.vertical"
          variant="h5"
          sx={{
            ml: '12px',
            mb: 2,
          }}
        >
          PARTNERS
        </GradientTypography>
      )}
      <Stack flexDirection="row" gap="16px 19px" flexWrap="wrap">
        {partners.map(({ logoUrl, name }, i) => {
          return (
            <PartnerCard logoUrl={logoUrl} name={name} key={`${name}-${i}`} />
          );
        })}
      </Stack>
    </Box>
  );
}
